module.exports = __webpack_public_path__ + "img/Image45.1e91f821.png";